import FloatingVue from 'floating-vue';

export default defineNuxtPlugin((nuxtApp) => {
  FloatingVue.options.themes.jungletooltip = {
    ...FloatingVue.options.themes.dropdown,
    $resetCss: false,
    placement: 'left',
  };
});
